import React from "react";
import { useState } from "react";
import { iconData } from "../../../../../iconData";
import MideaViewer from "../../../../../midea_viewer/MideaViewer";
import { Player } from "video-react";
import { IP } from "./../../../../../internalServer"
// all css comes in pdfType.css
const AttachmentDefault = ({ attach, fileSize }) => {
  const [mideaviewer, setMideaviewer] = useState();
  const [isClicked, setIsClicked] = useState(false)
  const [responseAttach, setResponseAttach] = useState();
  const [isError, setIsError] = useState(false);
  let attachments = Array.isArray(attach) ? attach : [attach];
  const attachformat = (para) => {
    if (para[0] !== undefined) {
      const filePath = para[0];
      const fileArr = filePath.split("/");
      const fileName = fileArr[fileArr.length - 1];
      const extractedFileName = fileName.split("_")[1];
      return extractedFileName;
    }
  };
  const normalizeFileSize = (fileSize) => {
    return fileSize > 1024 ? `${(fileSize / 1024).toFixed(0)}` : `${fileSize}`;
  };
  const handleClick = (attachment) => {
    setResponseAttach(attachment)
    setIsClicked(!isClicked);
  };
  const handleClickforpdf = (attachment) => {
    setTimeout(() => {
      setResponseAttach(attachment)
      setMideaviewer(true);
    }, 100)
  };
  return (
    <>
      <div className=" total_pdf m-1 ">
        <div className="all_pdf_pre" onClick={() => {
          const fileType = attachments[0].split(".").pop();
          if (fileType === "jpg" || fileType === "JPG" || fileType === "jpeg" || fileType === "png" || fileType === "mp4"
            || fileType === "JPG" || fileType === "JPEG" || fileType === "PNG" || fileType === "MP4"
          ) {
            handleClick(attachments[0]);
          } else if (fileType === "pdf" || fileType === "PDF" || fileType === 'doc' || fileType === 'docx') {
            handleClickforpdf(attachments[0]);
          }
        }}>
          <div className="pdf_logo">
            <>
              {attachments[0].split(".").pop() === "jpg" ||
                attachments[0].split(".").pop() === "JPG" ||
                attachments[0].split(".").pop() === "jpeg" ||
                attachments[0]?.split(".").pop() === "JPEG" ||
                attachments[0]?.split(".").pop() === "PNG" ||
                attachments[0]?.split(".").pop() === "mp4" ||
                attachments[0]?.split(".").pop() === "MP4" ||
                attachments[0].split(".").pop() === "png" ? (
                <div
                  // key={index}
                  onClick={() => {
                    if (!isError) {
                      handleClick(attachments[0]);
                    }
                  }}
                  className="ContainerUploadedPdf d-flex gap-2 p-1"
                >
                  <div className="d-flex align-items-center pdf_logo">
                    <img
                      src={`${iconData?.find(
                        (i) => i.extension === attachments[0]?.split(".").pop()
                      )?.icon
                        }`}
                      alt=""
                      className="attachLogoActivity"
                    />
                  </div>
                </div>
              ) : (
                <div className="d-flex align-items-center pdf_logo" onClick={() => handleClickforpdf(attachments[0])}>
                  <img
                    src={`${iconData?.find(
                      (i) => i.extension === attachments[0]?.split(".").pop()
                    )?.icon
                      }`}
                    alt=""
                    className="attachLogoActivity"
                  />
                </div>
              )}
            </>
          </div>
          <div className="pdf_detail">
            <div className=" d-flex align-itens-center justify-content-between"></div>
            <div className="pdf-txt2">{attachformat(attachments)}</div>

            <div className="pdf-txt3"> {fileSize?.length > 0 || fileSize ? normalizeFileSize(fileSize) + " KB" : null} </div>
          </div>
        </div>
      </div>
      {mideaviewer && (
        <MideaViewer
          closeMideaviewer={setMideaviewer}
          // attachment={attach?.name}
          attachment={responseAttach}
        />
      )}
      {isClicked &&
        (responseAttach.split(".").pop() === "mp4" || responseAttach.split(".").pop() === "MP4" ? (
          <div className="fullSizeImg ">
            <div className="SubfullSizeImg">
              <video className="videoPlayer" controls>
                <source src={IP + responseAttach.replace(/^\./, "")} type="video/mp4" />
              </video>
              <div>
                <img
                  className="crossIconImgQue"
                  onClick={handleClick}
                  src="/images/cross.png"
                  alt="Up Arrow"
                />
              </div>
            </div>
          </div>
        ) : (
          <div className="fullSizeImg ">
            <div className="SubfullSizeImg">
              {
                !isError ? (
                  <>
                    <img
                      className="imgMain"
                      src={IP + responseAttach?.replace(/^\./, "")}
                      alt="Full-size"
                      onError={(e) => {
                        setIsError(true)
                      }}
                    />
                    <div>
                      <img
                        className="crossIconImgQue"
                        onClick={handleClick}
                        src="/images/cross.png"
                        alt="Up Arrow"
                      />
                    </div>
                  </>
                ) : (
                  <div className="fullSizeImg" style={{ display: "flex", flexDirection: "column" }}>
                    <img
                      onClick={() => {
                        handleClick()
                        setIsError(false)
                      }}
                      src="/images/cross.png"
                      alt="Up Arrow"
                      style={{ position: "absolute", top: "75px", right: "40%" }}
                    />
                    <img src="/images/no-photo-1.png" alt="img" style={{ width: "25%" }} />
                    <p style={{ color: "red", fontSize: "20px", fontWeight: "500", marginRight: "35px" }}>Error!! failed to load the requested file!</p>
                  </div>
                )
              }

            </div>
          </div>
        ))}
    </>
  );
};

export default AttachmentDefault;
